#https://github.com/angular/angular.js/issues/7268 - Can not generate form dynamically in ng-repeat
#This decorator uses for fix this.
FormDecorator = ($provide) ->
  $provide.decorator "ngModelDirective", ['$delegate', ($delegate) ->
    ngModel = $delegate[0]
    originalCompile = ngModel.compile
    ngModel.compile = (element, attrs) ->
      nameAttr = attrs.name
      if nameAttr?.indexOf('{{') >= 0
        return {
          pre: (scope, elem, attrs) ->
            scope.$watch nameAttr, (newVal) ->
              if newVal?
                attrs.$set "name", newVal.toString()
        }

      if angular.isFunction(originalCompile)
        return originalCompile(element, attrs)

      originalCompile

    $delegate
  ]

  $provide.decorator "formDirective", ['$delegate', ($delegate) ->
    form = $delegate[0]
    originalCompile = form.compile
    form.compile = (element, attrs) ->
      nameAttr = attrs.name or attrs.ngForm
      if nameAttr?.indexOf('{{') >= 0
        return {
          pre: (scope, elem, attrs) ->
            scope.$watch nameAttr, (newVal) ->
              if newVal?
                attrs.$set "name", newVal.toString()
        }
      if angular.isFunction(originalCompile)
        return originalCompile(element, attrs)
      originalCompile
    $delegate
  ]

FormDecorator.$inject = ['$provide']

module.exports = FormDecorator



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/form-decorator-service.coffee